<!-- 晋级图 4强 || 6强 -->
<template>
  <div
    id="football_team4OrTeam8"
    :class="[themeClass, type, `matchNum${totalMatchNum}`]"
  >
    <div class="knockoutPage_head" v-if="!themeMode.includes('hideHeader')">
      <span
        class="headItem"
        v-for="head in headDatas"
        :key="head.key"
        :class="[head.class, head.key]"
        v-text="head.title"
      ></span>
    </div>
    <div class="knockoutPage_matchBox" v-show="type">
      <div
        class="matchBox_col"
        v-for="(group, gIndex) in matchList"
        :key="gIndex"
        :class="group.class"
      >
        <div
          class="matchBox_colItem"
          v-for="(knockout, kIndex) in group.list"
          :key="kIndex"
        >
          <div
            class="matchItem"
            v-for="item in knockout"
            :key="item.matchId"
            @click="goMatchDetail(item)"
          >
            <span
              class="match_date"
              v-text="matchDateWeb(item.matchDate, item.matchTime)"
            ></span>
            <div class="match_teams">
              <span class="match_team">
                <span class="match_team_image">
                  <img v-if="item.homeLogo" :src="item.homeLogo" />
                  <div v-else></div>
                </span>
                <span
                  class="match_team_name"
                  :class="
                    _valFormatHandler(item.homePoint) ? 'isShowPoint' : ''
                  "
                  v-text="item.homeName"
                ></span>
                <span class="match_team_score" v-text="item.homeScore != null ? item.homeScore : '-'"></span>
                <span
                  class="match_team_point"
                  v-show="_valFormatHandler(item.homePoint)"
                  v-text="`(${item.homePoint})`"
                ></span>
              </span>
              <span class="match_team">
                <span class="match_team_image">
                  <img v-if="item.awayLogo" :src="item.awayLogo" />
                  <div v-else></div>
                </span>
                <span
                  class="match_team_name"
                  :class="
                    _valFormatHandler(item.awayPoint) ? 'isShowPoint' : ''
                  "
                  v-text="item.awayName"
                ></span>
                <span class="match_team_score" v-text="item.awayScore != null ? item.awayScore : '-'"></span>
                <span
                  class="match_team_point"
                  v-show="_valFormatHandler(item.awayPoint)"
                  v-text="`(${item.awayPoint})`"
                ></span>
              </span>
            </div>
          </div>
          <!-- <div class="matchItem">
              <span class="match_date">2022.11.12 12:30</span>
              <div class="match_teams">
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
              </div>
            </div> -->
          <span class="promotionLine">
            <span class="promotionLine_one"></span>
            <span class="promotionLine_two"></span>
            <span class="promotionLine_three"></span>
          </span>
        </div>
        <!-- <div class="matchBox_colItem">
            <div class="matchItem">
              <span class="match_date">2022.11.12 12:30</span>
              <div class="match_teams">
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
              </div>
            </div>
            <div class="matchItem">
              <span class="match_date">2022.11.12 12:30</span>
              <div class="match_teams">
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
              </div>
            </div>
            <span class="promotionLine">
              <span class="promotionLine_one"></span>
              <span class="promotionLine_two"></span>
              <span class="promotionLine_three"></span>
            </span>
          </div> -->
        <div class="titleName_area" v-if="group.titleArr">
          <span
            class="match_title"
            v-for="(title, tIndex) in group.titleArr"
            :key="tIndex"
            v-text="title"
          ></span>
        </div>
      </div>

      <!-- <div class="matchBox_col col_1-4 arrowRight">
          <div class="matchBox_colItem">
            <div class="matchItem">
              <span class="match_date">2022.11.12 12:30</span>
              <div class="match_teams">
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
              </div>
            </div>
            <div class="matchItem">
              <span class="match_date">2022.11.12 12:30</span>
              <div class="match_teams">
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
              </div>
            </div>
            <span class="promotionLine">
              <span class="promotionLine_one"></span>
              <span class="promotionLine_two"></span>
              <span class="promotionLine_three"></span>
            </span>
          </div>
        </div>
        <div class="matchBox_col col_1-2 arrowRight">
          <div class="matchBox_colItem">
            <div class="matchItem">
              <span class="match_date">2022.11.12 12:30</span>
              <div class="match_teams">
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="matchBox_col col_1-2 arrowLeft">
          <div class="matchBox_colItem">
            <div class="matchItem">
              <span class="match_date">2022.11.12 12:30</span>
              <div class="match_teams">
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="matchBox_col col_1-4 arrowLeft">
          <div class="matchBox_colItem">
            <div class="matchItem">
              <span class="match_date">2022.11.12 12:30</span>
              <div class="match_teams">
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
              </div>
            </div>
            <div class="matchItem">
              <span class="match_date">2022.11.12 12:30</span>
              <div class="match_teams">
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
              </div>
            </div>
            <span class="promotionLine">
              <span class="promotionLine_one"></span>
              <span class="promotionLine_two"></span>
              <span class="promotionLine_three"></span>
            </span>
          </div>
        </div>
        <div class="matchBox_col arrowLeft">
          <div class="matchBox_colItem">
            <div class="matchItem">
              <span class="match_date">2022.11.12 12:30</span>
              <div class="match_teams">
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
              </div>
            </div>
            <div class="matchItem">
              <span class="match_date">2022.11.12 12:30</span>
              <div class="match_teams">
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
              </div>
            </div>
            <span class="promotionLine">
              <span class="promotionLine_one"></span>
              <span class="promotionLine_two"></span>
              <span class="promotionLine_three"></span>
            </span>
          </div>
          <div class="matchBox_colItem">
            <div class="matchItem">
              <span class="match_date">2022.11.12 12:30</span>
              <div class="match_teams">
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
              </div>
            </div>
            <div class="matchItem">
              <span class="match_date">2022.11.12 12:30</span>
              <div class="match_teams">
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
                <span class="match_team">
                  <span class="match_team_image">
                    <img />
                  </span>
                  <span class="match_team_name">球队名称</span>
                  <span class="match_team_score">3</span>
                </span>
              </div>
            </div>
            <span class="promotionLine">
              <span class="promotionLine_one"></span>
              <span class="promotionLine_two"></span>
              <span class="promotionLine_three"></span>
            </span>
          </div>
        </div> -->
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'football_team4OrTeam8',
  mixins: [cup_base_data_mixin],
  props: {
    datas: {
      type: Object,
      default: () => {
        return [
          //   {
          //     title: '1/8决赛',
          //     arr: [
          //       // 第一个元素是左边的，第二个元素是右边
          //       [
          //         {
          //           // 单场比赛的信息
          //           date: '2022-10-12',
          //           homeTeam: '主队',
          //           awayTeam: '客队',
          //         },
          //         {
          //           date: '2022-10-12',
          //           homeTeam: '主队',
          //           awayTeam: '客队',
          //         },
          //         {
          //           date: '2022-10-12',
          //           homeTeam: '主队',
          //           awayTeam: '客队',
          //         },
          //         {
          //           date: '2022-10-12',
          //           homeTeam: '主队',
          //           awayTeam: '客队',
          //         },
          //         {
          //           date: '2022-10-12',
          //           homeTeam: '主队',
          //           awayTeam: '客队',
          //         },
          //         {
          //           date: '2022-10-12',
          //           homeTeam: '主队',
          //           awayTeam: '客队',
          //         },
          //         {
          //           date: '2022-10-12',
          //           homeTeam: '主队',
          //           awayTeam: '客队',
          //         },
          //         {
          //           date: '2022-10-12',
          //           homeTeam: '主队',
          //           awayTeam: '客队',
          //         },
          //       ],
          //     ],
          //   },
          //   {
          //     title: '1/4决赛',
          //     arr: [
          //       // 第一个元素是左边的，第二个元素是右边
          //       [
          //         {
          //           date: '2022-10-12',
          //           homeTeam: '主队',
          //           awayTeam: '客队',
          //         },
          //         {
          //           date: '2022-10-12',
          //           homeTeam: '主队',
          //           awayTeam: '客队',
          //         },
          //         {
          //           date: '2022-10-12',
          //           homeTeam: '主队',
          //           awayTeam: '客队',
          //         },
          //         {
          //           date: '2022-10-12',
          //           homeTeam: '主队',
          //           awayTeam: '客队',
          //         },
          //       ],
          //     ],
          //   },
          //   {
          //     title: '半决赛',
          //     arr: [
          //       // 第一个元素是左边的，第二个元素是右边
          //       [
          //         {
          //           date: '2022-10-12',
          //           homeTeam: '主队',
          //           awayTeam: '客队',
          //         },
          //         {
          //           date: '2022-10-12',
          //           homeTeam: '主队',
          //           awayTeam: '客队',
          //         },
          //       ],
          //     ],
          //   },
          //   {
          //     title: '决赛',
          //     arr: [
          //       // 第一个元素冠军争夺赛，第二个元素是季军争夺赛
          //       [
          //         {
          //           date: '2022-10-12',
          //           homeTeam: '主队',
          //           awayTeam: '客队',
          //         },
          //         {
          //           date: '2022-10-12',
          //           homeTeam: '主队',
          //           awayTeam: '客队',
          //         },
          //       ],
          //     ],
          //   },
        ]
      },
    },
    themeClass: {
      // 控制css样式, 比如去掉鼠标选中效果；默认''是带鼠标效果
      type: String,
      default: '',
    },
    themeMode: {
      // 控制展示问题，['hideHeader']：隐藏掉顶部 knockoutPage_head
      type: Array,
      default: () => {
        return []
      },
    },
    detailPathName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      type: '',
      // headDatas: [
      //   {
      //     title: '1/8决赛',
      //     key: 'left_head_0',
      //     class: 'head_0',
      //   },
      //   {
      //     title: '1/4决赛',
      //     key: 'left_head_1',
      //     class: 'head_1',
      //   },
      //   {
      //     title: '半决赛',
      //     key: 'left_head_2',
      //     class: 'head_2',
      //   },
      //   {
      //     title: '决赛',
      //     key: 'left_head_3',
      //     class: 'head_3',
      //   },
      //   {
      //     title: '半决赛',
      //     key: 'right_head_2',
      //     class: 'head_2',
      //   },
      //   {
      //     title: '1/4决赛',
      //     key: 'right_head_1',
      //     class: 'head_1',
      //   },
      //   {
      //     title: '1/8决赛',
      //     key: 'right_head_0',
      //     class: 'head_0',
      //   },
      // ],
      headDatas_top8: [
        {
          title: '1/8决赛',
          key: 'left_head_top8_0',
          class: 'head_top8_width',
        },
        {
          title: '1/4决赛',
          key: 'left_head_top8_1',
          class: 'head_top8_width',
        },
        {
          title: '半决赛',
          key: 'left_head_top8_2',
          class: 'head_top8_width',
        },
        {
          title: '决赛',
          key: 'left_head_center',
          class: 'head_center',
        },
        {
          title: '半决赛',
          key: 'right_head_top8_2',
          class: 'head_top8_width',
        },
        {
          title: '1/4决赛',
          key: 'right_head_top8_1',
          class: 'head_top8_width',
        },
        {
          title: '1/8决赛',
          key: 'right_head_top8_0',
          class: 'head_top8_width',
        },
      ],
      headDatas_top4: [
        {
          title: '1/4决赛',
          key: 'left_head_top4_0',
          class: 'head_top4_width',
        },
        {
          title: '半决赛',
          key: 'left_head_top4_1',
          class: 'head_top4_width',
        },
        {
          title: '决赛',
          key: 'left_head_center',
          class: 'head_center',
        },
        {
          title: '半决赛',
          key: 'right_head_top4_1',
          class: 'head_top4_width',
        },
        {
          title: '1/4决赛',
          key: 'right_head_top4_0',
          class: 'head_top4_width',
        },
      ],
      headDatas_top16: [
        {
          title: '1/16决赛',
          key: 'left_head_top16_0',
          class: 'head_top16_width',
        },
        {
          title: '1/8决赛',
          key: 'left_head_top16_1',
          class: 'head_top16_width',
        },
        {
          title: '1/4决赛',
          key: 'left_head_top16_2',
          class: 'head_top16_width',
        },
        {
          title: '半决赛',
          key: 'left_head_top16_3',
          class: 'head_top16_width',
        },
        {
          title: '决赛',
          key: 'left_head_center',
          class: 'head_center',
        },
        {
          title: '半决赛',
          key: 'right_head_top16_3',
          class: 'head_top16_width',
        },
        {
          title: '1/4决赛',
          key: 'right_head_top16_2',
          class: 'head_top16_width',
        },
        {
          title: '1/8决赛',
          key: 'right_head_top16_1',
          class: 'head_top16_width',
        },
        {
          title: '1/16决赛',
          key: 'right_head_top16_0',
          class: 'head_top16_width',
        },
      ],
    }
  },
  computed: {
    totalMatchNum() {
      //展示几场比赛的晋级图
      let totalMatchNum = 0
      if (this.datas) {
        let datas = []
        datas =
          this.datas && this.datas.data && this.datas.data.dataList
            ? this.datas.data.dataList
            : []
        if (datas.length && datas.length === 5) {
          // 16强
          totalMatchNum = 32
        }
        if (datas.length && datas.length === 4) {
          // 8强
          totalMatchNum = 16
        }
        if (datas.length && datas.length === 3) {
          // 4强
          if (datas[0].matches.length === 2) {
            totalMatchNum = 6
          } else {
            totalMatchNum = 8
          }
        }
      }
      return totalMatchNum
    },
    matchList() {
      let matchList = []
      if (this.datas) {
        let leftMatch = []
        let rightMatch = []
        let centerMatch = []
        let datas = []
        datas =
          this.datas && this.datas.data && this.datas.data.dataList
            ? this.datas.data.dataList
            : []

        this.computedType(datas.length)
        console.debug('knockoutList:', this.datas, datas)
        if (datas.length && datas.length === 5) {
          // 16强
          datas.forEach((group, groupIndex) => {
            if (groupIndex != datas.length - 1) {
              const matches = group.matches

              let leftList = []
              let rightList = []
              if (matches.length == 16) {
                let list = []
                list.push(matches.slice(0, 2))
                list.push(matches.slice(2, 4))
                list.push(matches.slice(4, 6))
                list.push(matches.slice(6, 8))
                list.push(matches.slice(8, 10))
                list.push(matches.slice(10, 12))
                list.push(matches.slice(12, 14))
                list.push(matches.slice(14))
                leftList = list.slice(0, 4)
                rightList = list.slice(4)
              } else if (matches.length == 8) {
                let list = []
                list.push(matches.slice(0, 2))
                list.push(matches.slice(2, 4))
                list.push(matches.slice(4, 6))
                list.push(matches.slice(6))
                leftList = list.slice(0, 2)
                rightList = list.slice(2)
              } else {
                leftList = [matches.slice(0, group.matches.length / 2)]
                rightList = [matches.slice(group.matches.length / 2)]
              }
              leftMatch.push({
                key: `left_${group.code}`,
                class: `col_1-${group.matches.length} arrowRight`,
                list: leftList,
              })
              rightMatch.unshift({
                key: `right_${group.code}`,
                class: `col_1-${group.matches.length} arrowLeft`,
                list: rightList,
              })
            } else {
              let titleArr = []
              let onlyMatch = ''
              if (group.matches && group.matches.length == 1) {
                titleArr = ['冠军争夺赛']
                onlyMatch = 'onlyOneMatch'
              } else if (group.matches && group.matches.length == 2) {
                titleArr = ['冠军争夺赛', '季军争夺赛']
              }
              centerMatch.push({
                key: `center_${group.code}`,
                class: `col_1-1 centerMatch ${onlyMatch}`,
                list: [group.matches],
                titleArr,
              })
            }
          })
        }
        if (datas.length && datas.length === 4) {
          // 8强
          datas.forEach((group, groupIndex) => {
            if (groupIndex != datas.length - 1) {
              const matches = group.matches

              let leftList = []
              let rightList = []
              if (matches.length == 8) {
                let list = []
                list.push(matches.slice(0, 2))
                list.push(matches.slice(2, 4))
                list.push(matches.slice(4, 6))
                list.push(matches.slice(6))
                leftList = list.slice(0, 2)
                rightList = list.slice(2)
              } else {
                leftList = [matches.slice(0, group.matches.length / 2)]
                rightList = [matches.slice(group.matches.length / 2)]
              }
              leftMatch.push({
                key: `left_${group.code}`,
                class: `col_1-${group.matches.length} arrowRight`,
                list: leftList,
              })
              rightMatch.unshift({
                key: `right_${group.code}`,
                class: `col_1-${group.matches.length} arrowLeft`,
                list: rightList,
              })
            } else {
              let titleArr = []
              let onlyMatch = ''
              if (group.matches && group.matches.length == 1) {
                titleArr = ['冠军争夺赛']
                onlyMatch = 'onlyOneMatch'
              } else if (group.matches && group.matches.length == 2) {
                titleArr = ['冠军争夺赛', '季军争夺赛']
              }
              centerMatch.push({
                key: `center_${group.code}`,
                class: `col_1-1 centerMatch ${onlyMatch}`,
                list: [group.matches],
                titleArr,
              })
            }
          })
        }
        if (datas.length && datas.length === 3) {
          // 4强
          datas.forEach((group, groupIndex) => {
            if (groupIndex != datas.length - 1) {
              const matches = group.matches

              let leftList = []
              let rightList = []
              leftList = [matches.slice(0, group.matches.length / 2)]
              rightList = [matches.slice(group.matches.length / 2)]
              leftMatch.push({
                key: `left_${group.code}`,
                class: `col_1-${group.matches.length} arrowRight`,
                list: leftList,
              })
              rightMatch.unshift({
                key: `right_${group.code}`,
                class: `col_1-${group.matches.length} arrowLeft`,
                list: rightList,
              })
            } else {
              let titleArr = []
              let onlyMatch = ''
              if (group.matches && group.matches.length == 1) {
                titleArr = ['冠军争夺赛']
                onlyMatch = 'onlyOneMatch'
              } else if (group.matches && group.matches.length == 2) {
                titleArr = ['冠军争夺赛', '季军争夺赛']
              }
              centerMatch.push({
                key: `center_${group.code}`,
                class: `col_1-1 centerMatch ${onlyMatch}`,
                list: [group.matches],
                titleArr,
              })
            }
          })
        }
        matchList = [].concat(leftMatch, rightMatch, centerMatch)
        console.debug('matchList:', matchList)
      }
      return matchList
    },
    headDatas() {
      let headDatas = []
      if (this.datas) {
        let datas = []
        datas =
          this.datas && this.datas.data && this.datas.data.dataList
            ? this.datas.data.dataList
            : []
        if (datas.length && datas.length === 5) {
          headDatas = this.headDatas_top16
        } else if (datas.length && datas.length === 4) {
          headDatas = this.headDatas_top8
        } else if (datas.length && datas.length === 3) {
          headDatas = this.headDatas_top4
        }
      }
      return headDatas
    },
  },
  methods: {
    computedType(length) {
      if (length === 5) {
        this.type = 'team16'
      } else if (length === 4) {
        this.type = 'team8'
      } else if (length === 3) {
        this.type = 'team4'
      } else {
        this.type = ''
      }
    },
    goMatchDetail(item) {
      if (this.themeClass) return
      if (item && item.matchId && this.detailPathName) {
        let params = null
        if (
          [
            `scheduleDetailIndex_${this.currThemeObj.moduleRouteNameEn}`,
          ].includes(this.detailPathName) &&
          ['football', 'basketball'].includes(this.currThemeObj.sportType)
        ) {
          // 足球杯赛 || 篮球杯赛
          params = {
            cid: item.competitionId,
            sid: item.seasonId,
            mid: item.matchId,
          }
        } else if (
          this.detailPathName ===
          `badmintonScheduleDetail_${this.currThemeObj.moduleRouteNameEn}`
        ) {
          params = {
            cid: item.competitionId,
            sid: item.seasonId,
            sportsId: 'BDM',
            eventId: item.eventCode,
            mid: item.matchId,
          }
        }
        console.debug(this.detailPathName, params)
        this.pageJump(this.$router, this.detailPathName, params)
      }
    },
    matchDateWeb(date, time) {
      let matchDateWeb = ''
      if (date) {
        matchDateWeb += date
      }
      if (time) {
        matchDateWeb += ` ${time.substring(0, 5)}`
      }
      return matchDateWeb
    },
    _valFormatHandler(val, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        if (val && ceil) {
          data = `${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      // console.debug(val, data)
      return data.toString();
    },
  },
}
</script>

<style lang="scss" scoped>
#football_team4OrTeam8 {
  width: 100%;
  height: auto;
  .knockoutPage_head {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    background-color: var(--mixtmt_mainColor6);
    .headItem {
      height: 4.166vw;
      font-size: 1.388vw;
      color: var(--mixtmt_whiteColor);
      font-weight: bold;
      line-height: 4.166vw;
      text-align: center;
      &.head_top8_width {
        width: 10.76vw;
      }
      &.head_top16_width {
        width: 8.2vw;
      }
      /* &.head_0 {
        width: 10.76vw;
      }
      &.head_1 {
        width: 13.54vw;
      }
      &.head_2 {
        width: 10.76vw;
      } */
      &.head_center {
        flex: 1;
        text-align: center;
      }
      &.left_head_top8_0 {
        margin-right: 2.4vw;
      }
      &.left_head_top8_1 {
        margin-right: 2.1vw;
      }
      &.right_head_top8_0 {
        margin-left: 2.4vw;
      }
      &.right_head_top8_1 {
        margin-left: 2.1vw;
      }
      &.head_top4_width {
        width: 17.15vw;
      }
      &.left_head_top4_0 {
        margin-right: 1.6vw;
      }
      &.right_head_top4_0 {
        margin-left: 1.6vw;
      }
      &.left_head_top16_0 {
        margin-right: 2.4vw;
      }
      &.left_head_top16_1 {
        margin-right: 1.2vw;
      }
      &.left_head_top16_2 {
        margin-right: 1.0vw;
      }
      &.right_head_top16_0 {
        margin-left: 2.4vw;
      }
      &.right_head_top16_1 {
        margin-left: 1.2vw;
      }
      &.right_head_top16_2 {
        margin-left: 1.0vw;
      }
    }
  }
  .knockoutPage_matchBox {
    position: relative;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 57vw;
    padding: 2.778vw 0;
    .matchBox_col {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
      width: 13.54vw;
      height: 51.444vw;
      &.col_1-4 {
        justify-content: center;
        .matchBox_colItem {
          height: 38.75vw;
          .promotionLine {
            .promotionLine_one {
              height: 31.38vw;
            }
          }
        }
      }
      &.col_1-2 {
        justify-content: center;
        align-items: center;
        .matchBox_colItem {
          height: 7.36vw;
          .promotionLine {
            display: none;
          }
        }
      }
      &.col_1-1 {
        position: absolute;
        left: 50%;
        top: 2.22vw;
        z-index: 8;
        transform: translateX(-50%);
        width: 13.68vw;
        height: 45.498vw;
        &.onlyOneMatch {
          .matchBox_colItem {
            .promotionLine {
              .promotionLine_one {
                border: 0;
                border-top: 1px solid var(--mixtmt_mainColor5);
              }
            }
          }
        }
        .matchBox_colItem {
          padding: 0 1.46vw;
          height: 42.72vw;
          .matchItem {
            &:nth-child(2)::before {
              position: absolute;
              top: 50%;
              left: 0;
              content: '\20';
              transform: translateY(-50%);
              margin: -1px 0 0 -0.278vw;
              border-top: 0.208vw solid var(--mixtmt_whiteColor);
              border-bottom: 0.208vw solid var(--mixtmt_whiteColor);
              width: 0;
              height: 0;
              border-left: 0.278vw solid var(--mixtmt_mainColor5);
            }
            &:nth-child(2)::after {
              position: absolute;
              top: 50%;
              right: 0;
              content: '\20';
              transform: translateY(-50%);
              margin: -1px -0.278vw 0 0;
              border-top: 0.208vw solid var(--mixtmt_whiteColor);
              border-bottom: 0.208vw solid var(--mixtmt_whiteColor);
              width: 0;
              height: 0;
              border-right: 0.278vw solid var(--mixtmt_mainColor5);
            }
          }
          .promotionLine {
            width: 100%;
            height: 100%;
            .promotionLine_one {
              display: block;
              position: absolute;
              width: 100%;
              height: 12.84vw;
              bottom: 3.68vw;
            }
            .promotionLine_two {
              display: block;
              position: absolute;
              top: 7.66vw;
              height: 18.5vw;
              width: 1px;
            }
            .promotionLine_three {
              display: block;
              position: absolute;
              top: 7.36vw;
              border-right: 0.278vw solid var(--mixtmt_mainColor5);
              transform: rotate(90deg);
            }
          }
        }
        .titleName_area {
          position: absolute;
          left: 50%;
          top: 0;
          z-index: 6;
          width: 13.68vw;
          transform: translateX(-50%);
          .match_title {
            display: block;
            width: 100%;
            font-size: 1.11vw;
            height: 1.388vw;
            line-height: 1.388vw;
            font-weight: bold;
            text-align: center;
            color: rgba(0, 0, 0, 1);
            &:first-child {
              padding-top: 8.054vw;
            }
            &:nth-child(2) {
              padding-top: 35.362vw;
            }
          }
        }
      }
      .matchBox_colItem {
        position: relative;
        width: 100%;
        height: 19.58vw;

        .matchItem {
          position: absolute;
          z-index: 10;
          width: 10.76vw;
          height: auto;
          border: 1px solid transparent;
          &:first-child {
            top: 0;
          }
          &:nth-child(2) {
            bottom: 0;
          }
          .match_date {
            display: block;
            width: 100%;
            font-size: 0.833vw;
            line-height: 1.11vw;
            text-align: center;
            background-color: var(--mixtmt_mainColor5);
            color: var(--mixtmt_subColor_main);
          }
          .match_teams {
            width: 100%;
            padding: 0.556vw;
            background-color: var(--mixtmt_subColor_main);
            .match_team {
              width: 100%;
              display: flex;
              display: -webkit-flex;
              align-items: center;
              color: rgba(0, 0, 0, 0.85);
              &:nth-child(2) {
                padding-top: 0.694vw;
              }
              .match_team_image {
                width: 2.083vw;
                height: 2.083vw;
                overflow: hidden;
                flex-shrink: 0;
                img {
                  display: block;
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                }
                & > div {
                  width: 100%;
                  height: 100%;
                  background-color: var(--mixtmt_greyColor9);
                }
              }
              .match_team_name {
                width: calc(100% - 2.083vw - 1.388vw);
                font-size: 0.82vw;
                padding-left: 0.278vw;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                &.isShowPoint {
                  width: calc(100% - 2.083vw - 1.1vw - 1vw);
                }
              }
              .match_team_score {
                width: 1vw;
                font-size: 0.872vw;
                font-weight: bold;
                text-align: right;
              }
              .match_team_point {
                width: 1.1vw;
                font-size: 0.872vw;
                text-align: right;
              }
            }
          }
        }
        .promotionLine {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          left: 0;
          top: 50%;
          z-index: 5;
          transform: translateY(-50%);
          width: 100%;
          .promotionLine_one {
            width: 12.15vw;
            height: 12.15vw;
            border: 1px solid var(--mixtmt_mainColor5);
            background-color: var(--mixtmt_whiteColor);
            border-radius: 0.208vw;
          }
          .promotionLine_two {
            background-color: var(--mixtmt_mainColor5);
            width: calc(100% - 12.15vw - 0.278vw);
            height: 1px;
          }
          .promotionLine_three {
            border-top: 0.208vw solid transparent;
            border-bottom: 0.208vw solid transparent;
            width: 0;
            height: 0;
          }
        }
      }
      &.arrowRight {
        .matchBox_colItem {
          .matchItem {
            left: 0;
          }
          .promotionLine {
            .promotionLine_one {
              border-left: none;
            }
            .promotionLine_three {
              border-left: 0.278vw solid var(--mixtmt_mainColor5);
            }
          }
        }
      }
      &.arrowLeft {
        .matchBox_colItem {
          .matchItem {
            right: 0;
          }
          .promotionLine {
            flex-direction: row-reverse;
            .promotionLine_one {
              border-right: none;
            }
            .promotionLine_three {
              border-right: 0.278vw solid var(--mixtmt_mainColor5);
            }
          }
        }
      }
    }
  }
  &.team4 {
    .knockoutPage_matchBox {
      height: 42vw;
      .matchBox_col {
        width: 20.31vw;
        height: 35.44vw;
        .matchBox_colItem {
          .matchItem {
            width: 15.54vw;
          }
          .promotionLine {
            .promotionLine_one {
              width: 17.15vw;
            }
            .promotionLine_two {
              width: calc(100% - 17.15vw - 0.278vw);
            }
          }
        }
        &.col_1-1 {
          .matchBox_colItem {
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            .promotionLine {
              .promotionLine_one {
                width: 26.15vw;
              }
              .promotionLine_two {
                height: 11.3vw;
                width: 1px;
              }
            }
          }
          &.onlyOneMatch {
            .matchBox_colItem {
              .promotionLine {
                .promotionLine_one {
                  border: 0;
                  border-top: 1px solid var(--mixtmt_mainColor5);
                }
              }
            }
          }
          .titleName_area {
            .match_title {
              &:nth-child(2) {
                padding-top: 28vw;
              }
            }
          }
        }
        &.col_1-4 {
          .promotionLine {
            .promotionLine_one {
              height: 28.44vw;
            }
          }
        }
      }
    }
    &.matchNum6 {
      .knockoutPage_matchBox {
        .col_1-2 {
          &:first-child,
          &:nth-child(4) {
            .matchBox_colItem {
              .matchItem {
                margin-top: 6.08vw;
              }
              .promotionLine {
                display: flex;
                .promotionLine_one {
                  border-top: 0;
                  /* border-bottom: 0; */
                  height: 6.08vw;
                  margin-top: calc(6.08vw - 1px);
                  border-radius: 0;
                }
              }
            }
          }
        }
      }
    }
  }
  &.team16 {
    .knockoutPage_matchBox {
      height: 82vw;
      .matchBox_col {
        width: 10.155vw;
        height: 100%;
        .matchBox_colItem {
          height: 16vw;
          .matchItem {
            width: 9.2vw;
          }
          .promotionLine {
            .promotionLine_one {
              width: 9.4vw;
              height: 8.918vw;
            }
            .promotionLine_two {
              width: calc(100% - 9.4vw - 0.278vw);
            }
          }
        }
        // col_1-16: 4 colItems with explicit top offsets for 16强第一列
        &.col_1-16 {
          justify-content: space-between;
        }
        // col_1-8: 2 colItems positioned between col_1-16 pairs for 16强第二列
        &.col_1-8 {
          justify-content: space-between;
          // padding: 3.541vw 0;
          padding: 4vw 0;
          // gap: 12.8vw;
          .matchBox_colItem {
            height: 27.6vw;
            .promotionLine_one {
              height: 20vw;
            }
          }
        }
        // col_1-4: 1 colItem spanning from 1/16-1/8 左右连接中间的宽度
        &.col_1-4 {
          justify-content: flex-start;
          .matchBox_colItem {
            height: 48vw;
            margin-top: 14vw;
            .promotionLine {
              .promotionLine_one {
                height: 41vw;
              }
            }
          }
        }
        &.col_1-2 {
          justify-content: center;
          align-items: center;
          .matchBox_colItem {
            height: 7.36vw;
            .promotionLine {
              display: none;
            }
          }
        }
        &.col_1-1 {
          top: 10vw;
          height: 62vw;
          width: 11.2vw;
          .matchBox_colItem {
            padding: 0 1vw;
            height: 52vw;
            .matchItem {
              &:nth-child(2)::before {
                margin: -1px 0 0 -0.278vw;
                border-top: 0.208vw solid var(--mixtmt_whiteColor);
                border-bottom: 0.208vw solid var(--mixtmt_whiteColor);
                width: 0;
                height: 0;
                border-left: 0.278vw solid var(--mixtmt_mainColor5);
              }
              &:nth-child(2)::after {
                margin: -1px -0.278vw 0 0;
                border-top: 0.208vw solid var(--mixtmt_whiteColor);
                border-bottom: 0.208vw solid var(--mixtmt_whiteColor);
                width: 0;
                height: 0;
                border-right: 0.278vw solid var(--mixtmt_mainColor5);
              }
            }
            .promotionLine {
              .promotionLine_one {
                width: 100%;
                height: 17.4vw;
                bottom: 3.6vw;
              }
              .promotionLine_two {
                top: 7.4vw;
                height: 23.6vw;
                width: 1px;
              }
              .promotionLine_three {
                top: 7.16vw;
              }
            }
          }
          &.onlyOneMatch {
            .matchBox_colItem {
              .promotionLine {
                .promotionLine_one {
                  border: 0;
                  border-top: 1px solid var(--mixtmt_mainColor5);
                }
              }
            }
          }
          .titleName_area {
            .match_title {
              &:first-child {
                padding-top: 8vw;
              }
              &:nth-child(2) {
                padding-top: 44.6vw;
              }
            }
          }
        }
      }
    }
  }
}
.mixtmt_pc #football_team4OrTeam8:not(.onlyDisplay) {
  .knockoutPage_matchBox {
    .matchBox_col {
      .matchBox_colItem {
        .matchItem {
          cursor: pointer;
          &:hover {
            border: 1px solid var(--mixtmt_mainColor5);
            box-shadow: 1px 1px 8px 3px rgba(48, 3, 8, 0.15);
          }
        }
      }
    }
  }
}
</style>
